import styled from 'styled-components'

const Margin = styled.span`
	display: flex;
	height: ${({ height = 10 }) => height}px;
`

export default Margin
